import React from 'react';

export const TabExpander = () => (
  <div className='b-tab__expander' />
);
